<div class="top d-flex justify-content-between align-content-center flex-column">
  <nav class="navbar login-navbar">
    <img class="login-logo" src="assets/images/CDBlack.png" alt="NCS^ INDORE" />
  </nav>

  <div class="w-100 row d-flex justify-content-lg-center align-content-lg-center gx-lg-5 login-component">
    <div class="col-lg-5 left-card">
      <div class="card left-card-img shadow-none bg-transparent shadow-none rounded-0 mb-0" *ngIf="applicationLogo !== 0 && applicationLogo !== undefined;
        else fallbackLogo1">
        <img src="{{ getDoc(applicationLogo) }}" class="applicatin-img" width="458" alt="application logo" />
    </div>

    <ng-template #fallbackLogo1>
        <div class="card shadow-none bg-transparent shadow-none rounded-0 mb-0 left-card-img">
          <img src="assets/images/CDBlack.png" class="" width="500" alt="Fallback Logo" />
      </div>
    </ng-template>
  </div>

    <div class="col-lg-5 righ-card-top">
      <div class="card-body right-card">
        <div class="">
          <div class="text-center w-100 align-content-center application-logo"
            *ngIf="applicationLogo !== 0 && applicationLogo !== undefined">
            <img src="{{ getDoc(applicationLogo) }}" width="200px" height="115px" alt="AppLogo" />
          </div>
          <div class="text-center">
            <h1 class="login-application-name">
              {{ appName }}
            </h1>
          </div>

          <div class="text-center mb-1">
            <h5 class="pb-1">Sign In</h5>
            <form-error [form]="form"></form-error>
          </div>

          <div class="form-body">
            <form class="row g-3" #uiForm="ngForm">
                    <div class="col-12 mt-3">
                <label for="loginId">{{loginByOptionsText}}</label>
                <input [(ngModel)]="form.data['loginId']" type="email" class="form-control" id="loginId" name="loginId"
                   [placeholder]="loginPlaceholder" [readOnly]="isreadonly" required />
              </div>
              
                    <div class="col-12 mt-3">
                      <label for="password">Password</label>
                <div class="input-group" id="show_hide_password">
                  <input [type]="showPassword ? 'text' : 'password'" class="form-control border-end-0" id="password"
                    name="password" placeholder="Enter Password" [(ngModel)]="form.data['password']" required />

                  <a href="javascript:;" class="input-group-text bg-transparent" (click)="togglePasswordVisibility()">
                          <i class="bx" [class]="showPassword ? 'bx-show' : 'bx-hide'"></i>
                        </a>
                </div>
                      
              </div>
           
              <div *ngIf="!applicationLoadError" class="col-md-12 text-end">
                <a routerLink="/forgotpassword">Forgot Password ?</a>
              </div>
              <div class="col-12">
                <div class="d-grid">
                  <button type="submit" (click)="login()" [disabled]="!uiForm.valid || applicationLoadError" class="btn login-form-button">
                    Sign in
                  </button>
                </div>
              </div>
              <div class="col-12" *ngIf="enableUserSignup && !applicationLoadError">
                <div class="text-center">
                  <p class="mb-0">
                    Don't have an account yet?
                    <a routerLink="/signup">Sign up here</a>
                  </p>
                </div>
              </div>
            </form>
          </div>
          <div class="row mt-1">
            <div class="col-lg-12">
              <div class="w-100">
                <div class="text-center">
                  <span class="login-managed-by">Managed by</span>
                  <span class="org-name">{{ orgName }}</span>
                </div>
                <div class="row text-center" *ngIf="orgLogo !== 0 && orgLogo !== undefined;
                    else fallbackLogo">
                  <a target="_blank" title="Org logo">
                    <img class="org-logo" src="{{ getDoc(orgLogo) }}" alt="" />
                  </a>
                </div>
                <ng-template #fallbackLogo>
                  <div class="row text-center">
                    <a target="_blank" title="NCS Indore">
                      <img class="org-logo" src="assets/images/CDBlack.png" width="100px"/></a>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer">
    <p>Powered by NCS^ NO-CODE Platform Pvt. Ltd. </p>
  </footer>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Choose Role</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <select class="form-select" aria-label="Default select example">
          <option selected disabled value="undefined">--Select Role--</option>
          <option *ngFor="let c of rolelist" value="{{ c }}">{{ c }}
          </option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal content -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="staticBackdropLabel">Select Role</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModalFromTS(modal)"></button>
  </div>
  <div class="modal-body">
    <select class="form-select" aria-label="Default select example" (change)="roleChange($event)">
      <option selected disabled value="undefined">--Select Role--</option>
      <option *ngFor="let c of rolelist" [value]="c['applicationRoleId']">
         {{ c['applicationRoleName'] }}        
      </option>
    </select>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismissModalFromTS(modal)">Close</button>
    <button type="button" class="btn btn-outline-primary" (click)="closeModalFromTS(modal)">Select</button>
  </div>
</ng-template>
